import dataStore from '../../../data/data';
import SocketAudio from './audio';
import SocketLandmarks from './landmarks';
import SocketParticipants from './participants';

const SocketManager = (rtcPeer, socket) => {
  const data = dataStore.getState();
  const setData=dataStore.setState;

  const send = (message) => {
    socket.send(
      JSON.stringify({
        action: 'stream-audio',
        sessionId: data.mirror.sessionId,
        from: data.mirror.vitruvianId,
        message
      })
    );
  };

  setData((_data)=>({
    ..._data,
    mirror:{
      ..._data.mirror,
      socket:{
        ..._data.mirror.socket,
        send
      }
    }
  }));

  SocketLandmarks(socket);

  socket.addEventListener('message', async (event) => {
    const msg = JSON.parse(event.data);
    switch (msg.action || msg.type) {
      case 'participants-changed':
        await SocketParticipants();
        break;

      case 'stream-audio':
        await SocketAudio(msg,rtcPeer);
        break;

      case 'stream-landmarks':
        SocketLandmarks(socket,msg);
        break;

      default:
        break;
    }
  });

  return send;
};

export default SocketManager;